import { Table } from 'react-bootstrap';
import CustomTableBody from '../CustomTableBody';
import CustomTableFooter from '../CustomTableFooter';
import CustomTableHead from '../CustomTableHead';
import { ICustomTableProps } from './interfaces';

import './style.scss';

const CustomTable = <T,>(props: ICustomTableProps<T>) => {
  const { columnsMetadata } = props;
  const { footerProps, ...bodyProps } = props;

  return (
    <>
      <Table hover borderless responsive>
        <CustomTableHead columnsMetadata={columnsMetadata} />
        <CustomTableBody<T> {...bodyProps} />
      </Table>
      {footerProps ? <CustomTableFooter {...footerProps} /> : null}
    </>
  );
};

export default CustomTable;
